<template>
  <div>
    <b-row v-if="stockCheckSheet">
      <b-col>
        <p class="label-color font-size-print">
          {{ SUPPLIER_INFO.companyName }}
        </p>
      </b-col>
      <b-col></b-col>
      <b-col>
        <p class="label-color font-size-print text-right">
          Mẫu số 05 - VT<br />
          (Ban hành theo Thông tư số<br />
          133/2014/TT-BTC ngày<br />
          26/8/2016 của Bộ Tài<br />
          Chính)
        </p>
      </b-col>
    </b-row>
    <b-row>
      <div style="margin-left: 20px; margin-right: 20px; width: 100%">
        <h5
          class="label-color text-center font-size-print mb-2"
          style="font-size: 20px"
        >
          BIÊN BẢN KIỂM KÊ VẬT TƯ
        </h5>
        <p class="label-color text-center font-size-print mb-4">
          Địa điểm kiểm kê:
          {{ stockCheckSheet.storeName }}
        </p>
        <p class="m-0 font-size-print">
          Mã phiếu:
          <span class="font-weight-bold">{{ stockCheckSheet.code }}</span>
        </p>
        <p class="m-0 font-size-print">
          Thời gian kiểm kê:
          <span class="font-weight-bold">{{
            convertTime(stockCheckSheet.createdAt)
          }}</span>
        </p>
        <p class="m-0 font-size-print">
          Người lập phiếu:
          <span class="font-weight-bold">{{
            stockCheckSheet.createdByName
          }}</span>
        </p>
        <template v-if="stockCheckSheet.employeeCheckers && stockCheckSheet.employeeCheckers.length">
          <p
            v-for="(emp, idx) in stockCheckSheet.employeeCheckers"
            :key="emp.id || idx"
            class="m-0 font-size-print"
          >
            Nhân viên kiểm kê {{ idx + 1 }}:
            <span class="font-weight-bold">{{ emp.fullName }}</span>
          </p>
        </template>
        <p v-else class="m-0 font-size-print">
          Nhân viên kiểm kê:
          <span class="font-weight-bold">—</span>
        </p>
        
        <p class="m-0 font-size-print">
          Quản lý cửa hàng:
          <span class="font-weight-bold">{{
            stockCheckSheet.managerEmployeeName
          }}</span>
        </p>
        

        <p class="m-0 label-color font-size-print">Ban kiểm kê bao gồm:</p>
        <div class="mb-5">
          <b-row v-for="n in 3" :key="n">
            <b-col class="font-size-print">Ông/bà :</b-col>
            <b-col class="font-size-print">Chức vụ :</b-col>
            <b-col class="font-size-print">Đại diện :</b-col>
          </b-row>
        </div>
        <table class="table table-bordered-print col-md-12 mb-10">
          <tr>
            <th class="label-color align-middle text-center font-size-print">
              STT
            </th>
            <th class="label-color align-middle text-center font-size-print">
              MÃ HÀNG
            </th>
            <th class="label-color align-middle text-center font-size-print">
              TÊN HÀNG / IMEI
            </th>
            <th class="label-color align-middle text-center font-size-print">
              ĐVT
            </th>
            <th class="label-color align-middle text-center font-size-print">
              SL SỔ SÁCH
            </th>
            <th class="label-color align-middle text-center font-size-print">
              SL THỰC TẾ
            </th>
            <th class="label-color align-middle text-center font-size-print">
              CHÊNH LỆCH
            </th>
            <th class="label-color align-middle text-center font-size-print">
              ĐƠN GIÁ
            </th>
            <th class="label-color align-middle text-center font-size-print">
              THÀNH TIỀN
            </th>
          </tr>
          <tr v-if="diffProducts.length === 0">
            <td
              colspan="9"
              class="text-center align-middle font-size-print label-color"
            >
              Không có sản phẩm lệch tồn
            </td>
          </tr>
          <template v-else>
            <tr v-for="(item, index) in diffProducts" :key="item.id">
              <td class="text-center align-middle font-size-print">
                {{ index + 1 }}
              </td>
              <td class="text-left align-middle font-size-print">
                {{ item.productCode }}
              </td>
              <td class="text-left align-middle font-size-print">
                <div>
                  <p class="m-0 mb-1">{{ item.productName }}</p>
                  <div v-if="item.productType === PRODUCT_TYPE.PRODUCT_IMEI">
                    <p
                      v-if="item.imeiMissings && item.imeiMissings.length > 0"
                      style="
                        font-style: italic;
                        color: red;
                        font-size: 11px;
                        margin: 0;
                      "
                      class="font-size-gift"
                    >
                      Thiếu: {{ item.imeiMissings.join(', ') }}
                    </p>
                  </div>
                  <p
                    v-if="item.note"
                    style="font-style: italic; color: #555; font-size: 11px; margin: 0"
                    class="font-size-gift"
                  >
                    Ghi chú: {{ item.note }}
                  </p>
                </div>
              </td>
              <td class="text-center align-middle font-size-print">
                {{ item.unit }}
              </td>
              <td class="text-center align-middle font-size-print">
                {{
                  item.totalQuantityInStock +
                  item.totalQuantityHolding +
                  item.totalQuantityWarranty +
                  item.totalQuantityError
                }}
              </td>
              <td class="text-center align-middle font-size-print">
                {{ item.realStockQuantity }}
              </td>
              <td class="text-center align-middle font-size-print">
                {{
                  item.diffQuantity !== undefined
                    ? item.diffQuantity
                    : calcQuantityDeviations(item)
                }}
              </td>
              <td class="text-center align-middle font-size-print">
                {{ convertPrice(item.productPrice) }}
              </td>
              <td class="text-center align-middle font-size-print">
                {{ convertPrice(item.totalAmount) }}
              </td>
            </tr>
          </template>
          <tr>
            <td
              colspan="8"
              class="text-right align-middle font-size-print label-color"
              style="font-weight: bold"
            >
              TỔNG CỘNG:
            </td>
            <td
              class="text-center align-middle font-size-print label-color"
              style="font-weight: bold"
            >
              {{ convertPrice(totalAmount) }}
            </td>
          </tr>
        </table>
        <div class="signature-section">
          <b-row class="no-gutters">
            <b-col class="text-center">
              <p class="mb-0">
                <span class="label-color font-size-print">QL Cửa hàng</span>
              </p>
            </b-col>
            <b-col class="text-center">
              <p class="mb-0">
                <span class="label-color font-size-print">Kế toán</span>
              </p>
            </b-col>
            <b-col class="text-center">
              <p class="mb-0">
                <span class="label-color font-size-print">Ban kiểm kê</span>
              </p>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-row>
  </div>
</template>
<script>
import { convertPrice, formatDate } from '@/utils/common';
import { PRODUCT_TYPE } from '@/utils/enum';
import { SUPPLIER_INFO } from '@/utils/constants';

export default {
  props: ['printData'],
  watch: {
    printData: {
      handler(newPrintData) {
        this.stockCheckSheet = newPrintData.stockCheckSheet;
        this.stockCheckProducts = newPrintData.stockCheckProducts;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    convertPrice,
    formatDate,
    convertTime(created) {
      const createdTime = this.formatDate(created, 'HH:mm DD-MM-YYYY');
      const [time, year] = createdTime.split(' ');
      const [hour, minutes] = time.split(':');
      const [day, month, years] = year.split('-');
      return `${hour} giờ ${minutes} ngày ${day} tháng ${month} năm ${years}`;
    },
    calcQuantityDeviations(product) {
      return (
        product.realStockQuantity -
        (product.totalQuantityInStock +
          product.totalQuantityHolding +
          product.totalQuantityWarranty +
          product.totalQuantityError)
      );
    },
  },
  computed: {
    diffProducts() {
      return this.stockCheckProducts.filter((p) => p.diffQuantity !== 0);
    },
    totalAmount() {
      return (
        this.diffProducts.reduce((sum, product) => {
          return sum + (product.totalAmount || 0);
        }, 0) || 0
      );
    },
  },
  data() {
    return {
      PRODUCT_TYPE,
      stockCheckSheet: null,
      stockCheckProducts: [],
      SUPPLIER_INFO,
    };
  },
};
</script>
<style scoped>
.label-color {
  color: black;
  font-weight: 600;
}

.content-info {
  color: black;
  font-weight: 500;
}

.table-bordered-print th {
  border: 0.5px solid #474545;
}

.table-bordered-print td {
  border: 0.5px solid #474545;
}

.font-size-print {
  color: black;
  font-size: 13px;
}

.font-size-warranty {
  color: black;
  font-size: 13px;
}

.content-product {
  line-height: 1.375;
  white-space: pre-wrap;
  font-size: 13px;
  margin-top: 4px;
}

.font-size-gift {
  color: black;
  font-size: 12px;
}
</style>
